import request from '@/utils/request'

// 登录方法
export function login(username, password, code, uuid) {
  const data = {
    username,
    password,
    code,
    uuid
  }
  return request({
    url: '/login',
    method: 'post',
    data: data
  })
}

// 新闻列表
export function newsList(query) {
  let lang = localStorage.getItem('lang')
  query.contentType = lang;
  return request({
    url: "/cmsApi/news/list",
    method: 'get',
    params: query
  })
}

// 新闻详情
export function newsDetail(query) {
  return request({
    url: "/cmsApi/news/detail",
    method: 'get',
    params: query
  })
}

// 最新新闻详情
export function newsLatestDetail() {
  let lang = localStorage.getItem('lang')
  let query ={contentType:lang}
  return request({
    url: "/cmsApi/news/latest",
    method: 'get',
    params: query
  })
}

// 最新新闻详情
export function newsIndexLatest() {
  let lang = localStorage.getItem('lang')
  let query ={contentType:lang}
  return request({
    url: "/cmsApi/news/indexLatest",
    method: 'get',
    params: query
  })
}

// 分类列表
export function category() {
  let lang = localStorage.getItem('lang')
  let query ={contentType:lang}
  return request({
    url: '/cmsApi/news/category',
    method: 'get',
    params: query
  })
}

//会议历史
export function historyMeeting() {
  let lang = localStorage.getItem('lang')
  let query ={contentType:lang}
  return request({
    url: '/cmsApi/news/historyMeeting',
    method: 'get',
    params: query
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  })
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: '/captchaImage',
    method: 'get'
  })
}